import HamburgerIcon from '@/assets/icons/ic-menu.svg'
import { FC } from 'react'
import cn from '../lib/cn'

export interface HamburgerMenuProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
}

const HamburgerMenu: FC<HamburgerMenuProps> = ({ onClick, className }) => {
  return (
    <button
      className={cn(
        'h-20 w-20 flex justify-center items-center cursor-pointer',
        'lg:hidden text-white',
        className,
      )}
      onClick={onClick}
    >
      <img src={HamburgerIcon} alt="hamburger" className="w-6 h-6" />
    </button>
  )
}

export default HamburgerMenu
